





























import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';
import { DxNavBar } from 'devextreme-vue';
import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import SuppliersTable from '@/modules/rawMaterials/Components/SuppliersTable.vue';
import { RawMaterialStatusEnum } from '@/enums/rawMaterialStatusEnum';

import { DxDataGrid, DxColumn, DxEditing, DxStateStoring, DxColumnChooser, DxColumnFixing, DxFilterRow, DxSearchPanel } from 'devextreme-vue/data-grid';
import { RawMaterialGroup, RawMaterialGroupsClient } from '@/data/web-api-client';
import notificationService from '@/services/notificationService';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxSearchPanel,
    DxColumnChooser,
    DxColumnFixing,
    DxFilterRow,
    Card,
    Datagrid,
    DxNavBar,
    SuppliersTable,
  },
})
export default class RawMaterialsOverviewPage extends Vue {
  public navIndex: number = 0;

  private selectedTag: string = '';
  private pageSizes: number[] = [10, 25, 50, 100];
  private searchValue: string = '';
  private tempSearchValue: string = '';
  private paging: any = {
    pageSize: 20,
  };
  private pager: any = {
    showPageSizeSelector: true,
    allowedPageSizes: [10, 20, 50],
  };
  private showFilter: boolean = false;
  private rawMaterialGroups: RawMaterialGroup[] = [];

  public async mounted() {
    await this.getRawMaterialGroups();

    this.$store.dispatch('rawmaterials/fetch');
  }

  public edit(e: any) {
    this.$router.push({ path: `/rawmaterials/${e.row.data.id}` });
  }

  public cellclick(e: any) {
    if (e.data && e.column && e.column.type !== 'buttons') {
      this.$router.push({ path: `/rawmaterials/${e.data.id}` });
    }
  }

  public toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  private async getRawMaterialGroups() {
    try {
      const res = await new RawMaterialGroupsClient(undefined, this.$axios).getAll();

      this.rawMaterialGroups = res;
    } catch (err) {
      notificationService.failedToLoad();
    }
  }

  get rawMaterialStatusOptions() {
    const items = [
      { value: RawMaterialStatusEnum.Active, text: 'Actief' },
      { value: RawMaterialStatusEnum.Disabled, text: 'Inactief' },
    ];

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'text',
    };
  }

  get rawMaterialGroupsOptions() {
    const items = this.rawMaterialGroups.map((mg) => ({
      value: mg.id,
      text: mg.name,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
    };
  }

  public toolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'fas fa-filter',
        onClick: this.toggleFilter,
      },
    });
  }

  public add(e: any) {
    this.$router.push({ path: '/rawmaterials/add' });
  }

  public deleteRow(e: any) {
    this.$store.dispatch('rawmaterials/delete', e.data);
    e.cancel = true;
  }

  get items() {
    var rawmaterials = this.$store.getters['rawmaterials/items'] as any[];

    var filterMaterials: IRawMaterial[] = [];

    if (this.searchValue && this.searchValue !== '') {
      rawmaterials.forEach((x) => {
        if (x.name.toLowerCase().includes(this.searchValue)) {
          filterMaterials.push(x);
        } else if (x.measuringUnit.toLowerCase().includes(this.searchValue)) {
          filterMaterials.push(x);
        } else if (x.pricing != null) {
          x.pricing.forEach((w: { brand: string | null; kind: string | null }) => {
            if (w.brand != null && w.brand.toLowerCase().includes(this.searchValue)) {
              filterMaterials.push(x);
            } else if (w.kind != null && w.kind.toLowerCase().includes(this.searchValue)) {
              filterMaterials.push(x);
            }
          });
        }
      });
      rawmaterials = filterMaterials;
    }

    for (let rawMaterial of rawmaterials) {
      if (rawMaterial.pricing && rawMaterial.pricing.find((x: any) => x.default)) {
        rawMaterial['purchasePriceDefaultMeasuringUnit'] = rawMaterial.pricing.find((x: any) => x.default).purchasePriceDefaultMeasuringUnit;
      } else {
        rawMaterial['purchasePriceDefaultMeasuringUnit'] = 0;
      }
    }

    if (this.selectedTag && this.selectedTag !== '') {
      return rawmaterials.filter((o: any) => o.tags && o.tags.indexOf(this.selectedTag) !== -1);
    }
    return rawmaterials;
  }
  get loading() {
    return this.$store.getters['rawmaterials/loading'];
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-list', text: 'Overzicht' },
      { icon: 'fas fa-store-alt', text: 'Leveranciers' },
    ];
  }

  get toolbarOptions() {
    const self = this;

    return [
      {
        location: 'before',
        widget: 'dxLookup',
        options: {
          dataSource: new DataSource({
            store: new dxCustomStore({
              load: async (loadOptions) => {
                const result = this.$store.getters['catalogs/list']('WorkTypes');
                return {
                  data: result.values,
                };
              },
              byKey: (val: any) => {
                return val;
              },
            }),
            paginate: true,
          }),
          searchEnabled: true,
          showClearButton: true,
          width: 300,
          onValueChanged: (e: any) => {
            if (e && e.value) {
              self.selectedTag = e.value;
              return;
            }
            self.selectedTag = '';
          },
          placeholder: 'Filter op tag',
        },
      },
      {
        location: 'after',
        widget: 'dxTextBox',
        options: {
          width: 300,
          onOptionChanged: (e: any) => {
            if (e) {
              if (e.name == 'text') {
                self.tempSearchValue = e.value;
                self.search();
                return;
              }
            }
          },
          placeholder: 'Zoeken..',
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'fas fa-search',
          onClick: this.search,
        },
      },
    ];
  }

  get columns() {
    return [
      {
        dataField: 'name',
        caption: this.$t('objects.rawmaterials.Name'),
      },
      {
        dataField: 'description',
        caption: this.$t('objects.rawmaterials.Description'),
        visible: false,
      },
      {
        dataField: 'status',
        caption: 'Status',
        lookup: this.rawMaterialStatusOptions,
      },
      {
        dataField: 'materialGroup.id',
        caption: 'Grondstofgroep',
        lookup: this.rawMaterialGroupsOptions,
      },
      {
        dataField: 'measuringUnit',
        caption: this.$t('objects.rawmaterials.MeasuringUnit'),
      },
      {
        dataField: 'defaultPrice.purchasePrice',
        format: {
          type: 'currency',
          precision: 2,
        },
        alignment: 'left',
        caption: this.$t('objects.rawmaterials.CostPrice'),
      },
      {
        dataField: 'purchasePriceDefaultMeasuringUnit',
        caption: 'Prijs per eenheid',
        dataType: 'number',
        alignment: 'left',
        calculateDisplayValue: (item: any) => {
          if (!item || !item.purchasePriceDefaultMeasuringUnit) {
            return '€ 0';
          }
          const val = Math.round(item.purchasePriceDefaultMeasuringUnit * 10000) / 10000;
          return `€ ${val}`;
        },
        allowEditing: false,
      },
      {
        caption: this.$t('objects.rawmaterials.Pricing.SellingPrice'),
        alignment: 'left',
        columns: [
          {
            dataField: 'defaultPrice.salesPriceOrganisation',
            caption: 'B2B',
            dataType: 'number',
            alignment: 'left',
            format: { style: 'currency', currency: 'EUR', useGrouping: true },
          },
          {
            dataField: 'defaultPrice.salesPricePrivate',
            caption: 'B2C',
            dataType: 'number',
            alignment: 'left',
            format: { style: 'currency', currency: 'EUR', useGrouping: true },
          },
        ],
      },
      {
        type: 'buttons',
        buttons: [
          {
            hint: 'edit',
            icon: 'fas fa-edit',
            // visible: this.isCloneIconVisible,
            onClick: this.edit,
          },
          'delete',
        ],
      },
    ];
  }

  public search() {
    this.searchValue = this.tempSearchValue.toLowerCase();
  }
}
